module.exports = {
	"naslov": "Opkoljen si",
	"slika": "fotke/nemci/nemci-na-terenu-1943-1944.jpg",
	"opis": "Fašistički okupatori su opkolili zemunicu u kojoj se kriješ. Višestruko su nadmoćniji od tebe. Pozvan si da se predaš.",
	"pitanje": "Šta ćeš učiniti?",
	"izbori": [
		{
			"opis": "Pokušavam da bežim.",
			"link": "izbor1"
		},
		{
			"opis": "Otvaram vatru po zlikovcima!",
			"link": "izbor2"
		},
		{
			"opis": "Predajem se!",
			"link": "izbor3"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1944/01-15/podaci.json
// module id = 48
// module chunks = 0